<router-outlet></router-outlet>

<!-- Общий универсальный оверлей для модальных окон и сайдбаров -->
<app-ui-overlay></app-ui-overlay>

<!-- Модальные окна -->
<app-modal-outlet></app-modal-outlet>

<!-- Уведомления -->
@if (notifications()) {
  <div class="fixed right-2 top-2 z-[1001] flex flex-col gap-2 tma:top-safe-2">
    @for (notification of notifications(); track notification.id) {
      <app-ui-notification-card
        [type]="notification.type"
        [text]="notification.text"
        [id]="notification.id"
        (closeEvent)="removeNotification($event)"
      ></app-ui-notification-card>
    }
  </div>
}
